import React from "react";
import { FluentIcons } from "./icons";
import PropTypes from "prop-types";

export const FluentIconDefaults = {
  color: '#424242',
  size: 24,
};

const FluentUiIcon = ({
  name,
  color = FluentIconDefaults.color,
  size = FluentIconDefaults.size,
  disabled = false,
}) => {
  const Icon = FluentIcons[name];

  if (!Icon) {
    console.error(`Fluent UI Icon ${name} not found`);
    return null;
  }

  const iconStyle = {
    color,
    width: size,
    height: size,
    cursor: disabled ? "not-allowed" : "pointer",
    pointerEvents: disabled ? "none" : "auto",
  };

  return <Icon style={iconStyle} data-testid={name} disabled={disabled}/>;
};

FluentUiIcon.propTypes = {
  name: PropTypes.oneOf(Object.keys(FluentIcons)).isRequired,
  color: PropTypes.string,
  size: PropTypes.number,
  disabled: PropTypes.bool,
};

export default FluentUiIcon;